import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BpService } from '../../../core/services/bp.service';
import {
  RetailPlaceConnectVpnFields,
  RetailPlaceConnectVpnForm,
  RetailPlaceConnectVpnSignatureForm,
} from './vpn.model';

@UntilDestroy()
@Component({
  selector: 'tax-vpn',
  templateUrl: './vpn.component.html',
  styleUrls: ['./vpn.component.sass'],
})

export class VpnComponent implements OnInit {
  processForm?: RetailPlaceConnectVpnForm | RetailPlaceConnectVpnSignatureForm;

  constructor(
    private route: ActivatedRoute,
    private bpService: BpService,
  ) { }

  ngOnInit(): void {
    this.getProcessData();
  }

  goToSignStep(form: RetailPlaceConnectVpnFields): void {
    this.bpService.submitAndGetForm<RetailPlaceConnectVpnSignatureForm>(form)
      .pipe(
        untilDestroyed(this),
      )
      .subscribe((processForm) => {
        this.processForm = processForm;
      });
  }

  private getProcessData(): void {
    this.bpService.startBpAndGetData<RetailPlaceConnectVpnForm>('connectVpnRetailPlace', {
      retailPlaceId: Number(this.route.snapshot.params.id),
    })
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        this.processForm = response;
      });
  }
}
